module.exports = __webpack_public_path__ + "img/r05.f2dfb0cd.png";